import styles from './nav-bar.module.scss';
import { HeaderMenuButton } from '../header-menu-button';
import React, { useContext } from 'react';
import { HeaderStateContext } from '../../context/header-state-context';
import { jsx as _jsx } from "react/jsx-runtime";
export var NavBarItem = function NavBarItem(_ref) {
  var item = _ref.item;

  var _useContext = useContext(HeaderStateContext),
      resetNavBarState = _useContext.resetNavBarState;

  return /*#__PURE__*/_jsx("li", {
    className: "".concat(styles.navBarItem, " align-self-xl-center"),
    onMouseEnter: resetNavBarState,
    role: "menuitem",
    children: /*#__PURE__*/_jsx(HeaderMenuButton, {
      path: item === null || item === void 0 ? void 0 : item.path,
      title: item === null || item === void 0 ? void 0 : item.title
    })
  });
};